import NamedDto from 'modules/base/dto/NamedDto';

export class UserGroupEditDto extends NamedDto {
	constructor() {
		super();
	}

	/**
	 * @typedef {Object} _UserGroupEditDtoProps
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _UserGroupEditDtoProps} UserGroupEditDtoProps
	 */
	/**
	 *
	 * @param {UserGroupEditDtoProps} props
	 * @returns {UserGroupEditDto}
	 */
	setup(props) {
		super.setup(props);

		return this;
	}
}

export default UserGroupEditDto;
